import Vue from 'vue';
import Router from 'vue-router';
const S = window.sessionStorage
Vue.use(Router);
import index from './view/index/index'
// import check from './view/check/check.vue'
import home from './view/home/home'
import worker from './view/my/worker'
import login from './view/index/login'
import homeland from './view/index/homeland'
import my from './view/my/my'
import mine from './view/my/mine'
import target from './view/my/target'
import auditHistory from './view/my/auditHistory'

const routes = [
  {
    path: '*',
    redirect: () => {
      return '/index'
      // let cookie = window.document.cookie.length > 0
      // let now = Math.round(new Date().getTime() / 1000)
      // let lt = window.localStorage.getItem('loginTime')
      // let loginState
      // if (lt) {
      //   loginState = (now - Number(lt) < 86000) && cookie
      // } else {
      //   loginState = false
      // }
      // if (!loginState) {
      //   console.log(87878, loginState)
      //   return '/login'
      // } else {
      //   return '/homeland'
      // }
    }
  },
  {
    name: 'login',
    component: login,
    meta: {
      title: '东坡区民政局年审管理'
    }
  },
  {
    name: 'homeland',
    component: homeland,
    meta: {
      title: '东坡区民政局年审管理'
    }
  },
  {
    name: 'worker',
    component: worker,
    meta: {
      title: '东坡区民政局年审管理'
    }
  },
  {
    name: 'index',
    component: index,
    meta: {
      title: '东坡区民政局年审管理'
    }
  },
  {
    name: 'target',
    component: target,
    meta: {
      title: '东坡区民政局年审管理'
    }
  },
  {
    name: 'home',
    component: home,
    meta: {
      title: '东坡区民政局年审管理',
      allowBack: false
    }
  },
  {
    name: 'auditHistory',
    component: auditHistory,
    meta: {
      title: '东坡区民政局年审管理'
    }
  },
  {
    name: 'mine',
    component: mine,
    meta: {
      title: '东坡区民政局年审管理'
    }
  },
  {
    name: 'my',
    component: my,
    meta: {
      // title: '我的'，
      title: '年审'
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
